import { QueryFactory } from "../../../../Common";
import { Player } from "../../../../Contracts";
export const QGetLimitsHistory = QueryFactory(Player.QueryTypes.GetLimitsHistory);
//# sourceMappingURL=QGetLimitsHistory.js.map